import { fetchApi } from '~/utils';
import { squireApiConfig } from '~/config';

const { url } = squireApiConfig;

export class PermissionsApiService {
  async getPermissionsForSignedInUser() {
    return await fetchApi(`${url}/v1/permissions-context/`, 'GET');
  }
}
